// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","textLarge":"Logo_textLarge__4mW0Y","extraText":"Logo_extraText__Wu2AB"};